<commessa>
    <div class="bg-cyan-700 text-white rounded-lg p-8 mt-5">
        <div class="mt-6 flex flex-col gap-x-8 gap-y-20 lg:flex-row">
            <div class="lg:flex-1">
                <h2 class="text-lg font-bold flex gap-2 items-center"><span>{ state.commessa ? state.commessa.numero : '' }</span><span class="font-medium text-black">del { state.commessa && state.commessa.data ? formatDate(state.commessa.data) : '' }</span><img src="{ state.commessa && state.commessa.societa ? getLogo(state.commessa.societa) : '' }"></h2>
                <h1 class="mt-2 text-2xl font-bold tracking-tight sm:text-3xl text-cyan-100">{ state.commessa ? state.commessa.titolo.length ? state.commessa.titolo : '' : 'Caricamento commessa in corso...' }</h1>
                <h3 class="mt-2 text-lg flex gap-2 items-center text-black"><span class="font-black">{ state.commessa && state.commessa.cliente ? state.commessa.cliente : '' }</span><span>/</span><span class="font-base">{ state.commessa && state.commessa.categoria ? state.commessa.categoria : '-' }</span></h3>
                <p if="{ state.commessa && state.commessa.descrizione }" class="mt-8 text-base font-medium text-pretty">
                    <strong>DESCRIZIONE</strong><br />
                    { state.commessa ? state.commessa.descrizione : '' }
                </p>
                <p if="{ state.commessa && state.commessa.brief }" class="mt-4 text-base font-medium text-pretty">
                    <strong>BRIEF</strong><br />
                    { state.commessa && state.commessa.brief }
                </p>
            </div>
            <div class="lg:flex lg:flex-none lg:justify-center">
                <dl class="w-64 space-y-8 xl:w-96 divide-y divide-cyan-200">
                    <div class="px-4 py-1 mb-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-cyan-50">Data di scadenza</dt>
                        <dd class="text-sm font-bold text-end">{ state.commessa && state.commessa.dataScadenza ? formatDate(state.commessa.dataScadenza) : '-' }</dd>
                    </div>
                    <div class="px-4 py-1 mb-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-cyan-50">Account di riferimento</dt>
                        <dd class="text-sm font-semibold text-end">{ state.commessa && state.commessa.account ? state.commessa.account : '-' }</dd>
                    </div>
                    <div class="px-4 py-1 mb-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-cyan-50">Risorse assegnate</dt>
                        <dd class="text-sm font-semibold text-end">{ state.commessa && state.commessa.risorsa ? splitRisorsa(state.commessa.risorsa) : '-' }</dd>
                    </div>
                    <div class="px-4 py-1 mt-6 mb-1 sm:grid sm:grid-cols-2 sm:gap-4 sm:px-0">
                        <dt class="text-sm font-cyan-50"></dt>
                        <dd class="text-sm font-semibold text-end">
                        <progress-bar ckey="perc_ore"></progress-bar>
                        <div class="pt-1">{ state.commessa && state.commessa.oreTotali ? state.commessa.oreTotali : '0'}h / { state.commessa && state.commessa.orePreventivate ? state.commessa.orePreventivate : '0' }h<div class="text-black font-medium">{ state.commessa && state.commessa.deltaOre ? 'differenza: ' + state.commessa.deltaOre + 'h' : '' }</div></div>
                        </dd>
                    </div>
                </dl>
            </div>
        </div>
    </div>
    <div class="bg-white rounded-lg p-8 mt-5">
        <div class="mb-6">
            <div class="grid grid-cols-1 sm:hidden">
                <select class="col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pr-8 pl-3 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600" onchange="{
                            setCurrentTab.bind(this)
                        }">
                    <option value="{ KEYS.TASK }" selected={ state.currentTab == KEYS.TASK }>Task</option>
                    <option value="{ KEYS.ORE }" selected={ state.currentTab == KEYS.ORE }>Ore</option>
                </select>
                <svg class="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end fill-gray-500" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" data-slot="icon">
                <path fill-rule="evenodd" d="M4.22 6.22a.75.75 0 0 1 1.06 0L8 8.94l2.72-2.72a.75.75 0 1 1 1.06 1.06l-3.25 3.25a.75.75 0 0 1-1.06 0L4.22 7.28a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
                </svg>
            </div>
            <div class="hidden sm:block">
                <div class="border-b border-gray-200">
                    <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                        <span onclick="{
                                    setCurrentTab.bind(this, KEYS.TASK)
                                }" class="cursor-pointer group inline-flex items-center border-b-2 px-1 py-4 text-lg font-medium { state.currentTab == KEYS.TASK ? 'border-cyan-500 text-cyan-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700' }">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 { state.currentTab == 'task' ? 'text-cyan-500' : 'text-gray-400 group-hover:text-gray-500' }">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z" />
                            </svg>
                            <span>Task</span>
                        </span>
                        <span onclick="{
                                    setCurrentTab.bind(this, KEYS.ORE)
                                }" class="cursor-pointer group inline-flex items-center border-b-2 px-1 py-4 text-lg font-medium { state.currentTab == KEYS.ORE ? 'border-cyan-500 text-cyan-600' : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700' }"">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 { state.currentTab == 'ore' ? 'text-cyan-500' : 'text-gray-400 group-hover:text-gray-500' }">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            </svg>
                            <span>Ore</span>
                        </span>
                    </nav>
                </div>
            </div>
        </div>
        <div if="{ state.currentTab == KEYS.TASK }">
            <div class="flex justify-end">
                <div class="filters">
                    <form class="flex gap-4 items-center" method="POST" onsubmit="{
                                filterTask
                            }">
                        <combobox label="" ckey="filtro_risorsa_task" placeholder="Filtra per risorsa..."></combobox>
                        <combobox label="" ckey="filtro_stato_task" placeholder="Filtra per stato..."></combobox>
                        <input-text ckey="search_text" placeholder="Cerca..."></input-text>
                        <my-button type="submit" is_square="1">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                            </svg>
                        </my-button>
                    </form>
                </div>
            </div>
            <generic-table 
                ckey="{ KEYS.TASK }" 
                columns="{ state.columns_task }"
                rows="{ state.rows_task }"
                total_rows="{ state.total_rows_task }"
                page_size="{ state.page_size }"
                current_page="{ state.current_page_task }"
                condensed="1" 
                >
                <template slot="editable">
                    <div if="{ column.field === 'stato' }">
                        <combobox
                            ckey="stato_{row.id}"
                            value="{ row.stato }"
                            label="" />
                    </div>
                </template>
                <my-button
                    slot="actions"
                    ckey="{ KEYS.ORE }"
                    row="{ row }"
                    type="button"
                    onclick="{
                                saveTask.bind(this, row)
                            }"
                    >Salva</my-button>
            </generic-table>
        </div>
        <div if="{ state.currentTab == KEYS.ORE }">
            <div class="flex justify-between">
                <div class="add">
                    <my-button 
                        ckey="{ KEYS.ORE }"
                        type="button"
                        onclick="{
                                    create.bind(this, {ckey: KEYS.ORE})
                                }"
                        >Aggiungi <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                        </svg>
                    </my-button>
                </div>
                <div class="filters">
                    <form class="flex gap-4 items-center" method="POST" onsubmit="{
                                filterOre
                            }">
                        <combobox label="" ckey="filtro_risorsa_ore" placeholder="Filtra per risorsa..."></combobox>
                        <input-text ckey="search_text" placeholder="Cerca..."></input-text>
                        <my-button type="submit" is_square="1">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                            <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                            </svg>
                        </my-button>
                    </form>
                </div>
            </div>
            <generic-table 
                ckey="{ KEYS.ORE }" 
                columns="{ state.columns_ore }"
                rows="{ state.rows_ore }"
                total_rows="{ state.total_rows_ore }"
                page_size="{ state.page_size }"
                current_page="{ state.current_page_ore }"
                condensed="1" 
                >
                <button-group
                    slot="actions"
                    ckey="{ KEYS.ORE }"
                    row="{ row }"
                    options="{ [
                    { label: 'Modifica riga', action: ACTIONS.EDIT },
                    { label: 'Elimina riga', action: ACTIONS.DELETE }
                    ] }"
                    ></button-group>
            </generic-table>
        </div>
        <modal-delete ckey="{ KEYS.ORE }"></modal-delete>
        <modal-ore ckey="{ KEYS.ORE }" id_commessa="{ props.id_commessa }"></modal-ore>
        <modal-result ckey="{ KEYS.ORE }"></modal-result>
        <modal-error ckey="{ KEYS.COMMESSA }"></modal-error>
    </div>

    <script>
        import StoreService from '/src/services/store'
        import eventBus from '/src/utils/event-bus'
        import { fetchComboboxRisorse, fetchComboboxStatiTask, isNumeric, getLogo } from '/src/utils/functions'
        import moment from 'moment-with-locales-es6'
        import { CONFIG, EVENTS, KEYS, ACTIONS } from '/src/utils/constants'

        export default {

            ACTIONS: ACTIONS,
            KEYS: KEYS,
            getLogo: getLogo,

            onBeforeMount(props, state) {
                this.state = {
                    commessa: null,
                    columns_task: [
                        {type: CONFIG.DATE, label: 'Data', field: 'data', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Descrizione', field: 'descrizione', is_wrappable: true},
                        {type: CONFIG.TEXT, label: 'Note', field: 'note', is_wrappable: true},
                        {type: CONFIG.TEXT, label: 'Risorsa', field: 'risorsa'},
                        {type: CONFIG.DATE, label: 'Data inizio', field: 'data_inizio', is_sortable: true},
                        {type: CONFIG.DATE, label: 'Data fine', field: 'data_fine', is_sortable: true},
                        {type: CONFIG.EDITABLE, label: 'Stato', field: 'stato'}
                    ],
                    rows_task: [],
                    total_rows_task: 0,
                    current_page_task: 1,
                    sort_column_task: 'data',
                    sort_direction_task: 'asc',
                    search_risorsa_task: '',
                    search_stato_task: '',
                    search_text_task: '',
                    columns_ore: [
                        {type: CONFIG.DATE, label: 'Data', field: 'data', is_sortable: true},
                        {type: CONFIG.TEXT, label: 'Descrizione', field: 'descrizione', is_wrappable: true},
                        {type: CONFIG.TEXT, label: 'Note', field: 'note', is_wrappable: true},
                        {type: CONFIG.TEXT, label: 'Risorsa', field: 'risorsa'},
                        {type: CONFIG.TEXT, label: 'Ore', field: 'quantita'}
                    ],
                    rows_ore: [],
                    total_rows_ore: 0,
                    current_page_ore: 1,
                    sort_column_ore: 'data',
                    sort_direction_ore: 'asc',
                    search_risorsa_ore: '',
                    search_text_ore: '',
                    page_size: CONFIG.N_ITEMS,
                    currentTab: KEYS.TASK
                }
                eventBus.on(EVENTS.UI.CHANGE_PAGE, this.handlePageChange)
                eventBus.on(EVENTS.UI.SORTING_CHANGE, this.handleSortChange)
                eventBus.on(EVENTS.UI.CLICK_BUTTON_GROUP, this.handleClickAction)
                eventBus.on(EVENTS.ITEMS.REFRESH, this.handleRefresh)
                eventBus.on(EVENTS.ITEMS.DELETE, this.handleDelete)
            },

            async onMounted(props, state) {
                const commessa = await StoreService.fetchCommessa(props.id_commessa);
                let percentOre = 0;
                if (isNumeric(commessa.oreTotali) && isNumeric(commessa.orePreventivate)) {
                    percentOre = parseFloat(commessa.oreTotali) / parseFloat(commessa.orePreventivate)
                }
                this.update({
                    commessa: commessa
                })
                eventBus.trigger(EVENTS.INPUT.UPDATE, {
                    ckey: 'perc_ore',
                    value: percentOre
                })
                fetchComboboxRisorse().then(risorse => {
                    eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                        ckey: 'filtro_risorsa_task',
                        items: risorse
                    });
                    eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                        ckey: 'filtro_risorsa_ore',
                        items: risorse
                    });
                });
                fetchComboboxStatiTask().then(stati => {
                    eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                        ckey: 'filtro_stato_task',
                        items: stati
                    });
                });
                this.fetchDataTask()
                this.fetchDataOre()
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.UI.CHANGE_PAGE, this.handlePageChange)
                eventBus.off(EVENTS.UI.SORTING_CHANGE, this.handleSortChange)
                eventBus.off(EVENTS.UI.CLICK_BUTTON_GROUP, this.handleClickAction)
                eventBus.off(EVENTS.ITEMS.REFRESH, this.handleRefresh)
                eventBus.off(EVENTS.ITEMS.DELETE, this.handleDelete)
            },

            handleRefresh(e) {
                if (e.ckey === KEYS.TASK) {
                    this.fetchDataTask()
                } else if (e.ckey === KEYS.ORE) {
                    this.fetchDataOre()
                }
            },

            async handleDelete(e) {
                switch (e.ckey) {
                    case KEYS.ORE:
                        await StoreService.deleteOra(e.item_id)
                        this.fetchDataOre()
                        break
                }
            },

            handleClickAction(e) {
                if (e.ckey === KEYS.ORE) {
                    switch (e.action) {
                        case ACTIONS.EDIT:
                            eventBus.trigger(EVENTS.UI.OPEN_MODAL_ORE, {
                                ckey: KEYS.ORE,
                                data: e.data
                            })
                            break
                        case ACTIONS.DELETE:
                            eventBus.trigger(EVENTS.UI.OPEN_MODAL_DELETE, {
                                ckey: KEYS.ORE,
                                title: 'Cancellazione riga',
                                text: 'Sei sicuro di voler eliminare la riga?',
                                item_id: e.data.id
                            })
                    }
                }
            },

            create(e) {
                if (e.ckey === KEYS.ORE) {
                    eventBus.trigger(EVENTS.UI.OPEN_MODAL_ORE, {
                        ckey: KEYS.ORE,
                        data: {
                            id_commessa: this.props.id_commessa
                        }
                    })
                }
            },

            handlePageChange(e) {
                if (e.ckey === KEYS.TASK) {
                    this.update({current_page_task: e.page})
                    this.fetchDataTask()
                } else if (e.ckey === KEYS.ORE) {
                    this.update({current_page_ore: e.page})
                    this.fetchDataOre()
                }
            },

            handleSortChange(e) {
                if (e.ckey === KEYS.TASK) {
                    this.update({
                        sort_column_task: e.column,
                        sort_direction_task: e.direction,
                        current_page_task: 1 // Torna alla prima pagina
                    })
                    this.fetchDataTask();
                } else if (e.ckey === KEYS.ORE) {
                    this.update({
                        sort_column_ore: e.column,
                        sort_direction_ore: e.direction,
                        current_page_ore: 1 // Torna alla prima pagina
                    });
                }
            },

            async fetchDataTask() {
                const {sort_column_task, sort_direction_task, current_page_task, search_risorsa_task, search_stato_task, search_text_task} = this.state;
                const where = {};
                if (search_risorsa_task) {
                    where.risorsa = search_risorsa_task
                }
                if (search_stato_task) {
                    where.stato = search_stato_task
                }
                where.id_commessa = this.props.id_commessa
                const result = await StoreService.fetchTask(
                        sort_column_task,
                        sort_direction_task,
                        current_page_task,
                        search_text_task,
                        where
                        );
                if (result.items) {
                    this.update({
                        rows_task: result.items,
                        total_rows_task: result.total
                    })
                    eventBus.trigger(EVENTS.ITEMS.CHANGED, {
                        ckey: KEYS.TASK,
                        items: {
                            count: this.state.total_rows_task,
                            results: this.state.rows_task
                        },
                        page: this.state.current_page_task
                    })
                    fetchComboboxStatiTask().then(stati => {
                        result.items.forEach(row => {
                            eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                                ckey: `stato_${row.id}`,
                                items: stati
                            });
                        });
                    });
                } else {
                    console.error('Errore nel caricamento dei dati:', result.error)
                }
            },

            async fetchDataOre() {
                const {sort_column_ore, sort_direction_ore, current_page_ore, search_risorsa_ore, search_text_ore} = this.state;
                const where = {};
                if (search_risorsa_ore) {
                    where.risorsa = search_risorsa_ore
                }
                where.id_commessa = this.props.id_commessa
                const result = await StoreService.fetchOre(
                        sort_column_ore,
                        sort_direction_ore,
                        current_page_ore,
                        search_text_ore,
                        where
                        );
                if (result.items) {
                    this.update({
                        rows_ore: result.items,
                        total_rows_ore: result.total
                    })
                    eventBus.trigger(EVENTS.ITEMS.CHANGED, {
                        ckey: KEYS.ORE,
                        items: {
                            count: this.state.total_rows_ore,
                            results: this.state.rows_ore
                        },
                        page: this.state.current_page_ore
                    })
                } else {
                    console.error('Errore nel caricamento dei dati:', result.error)
                }
            },

            filterTask(e) {
                e.preventDefault(); // Evita il refresh della pagina
                const filtroRisorsa = document.getElementById('filtro_risorsa_task')?.value || '';
                const filtroStato = document.getElementById('filtro_stato_task')?.value || '';
                const searchText = document.getElementById('search_text_task')?.value || '';
                // Aggiorna lo stato con i filtri attivi
                this.update({
                    search_risorsa_task: filtroRisorsa,
                    search_stato_task: filtroStato,
                    search_text_task: searchText,
                    current_page_task: 1 // Reset alla prima pagina
                });
                // Effettua una nuova query
                this.fetchDataTask();
            },

            filterOre(e) {
                e.preventDefault(); // Evita il refresh della pagina
                const filtroRisorsa = document.getElementById('filtro_risorsa_ore')?.value || '';
                const searchText = document.getElementById('search_text_ore')?.value || '';
                // Aggiorna lo stato con i filtri attivi
                this.update({
                    search_risorsa_ore: filtroRisorsa,
                    search_text_ore: searchText,
                    current_page_ore: 1 // Reset alla prima pagina
                });
                // Effettua una nuova query
                this.fetchDataOre();
            },

            splitRisorsa(risorse) {
                if (typeof risorse === 'string' && risorse.includes('\r')) {
                    risorse = risorse.replace(/\r/g, ', ')
                }
                return risorse
            },

            formatDate(d) {
                return moment.utc(d).local().format('DD/MM/YYYY')
            },

            setCurrentTab(e) {
                let tab = null
                if (e instanceof Event) {
                    tab = e.target.value
                } else if (typeof e === 'string' || e instanceof String) {
                    tab = e
                }
                if (tab === KEYS.TASK) {
                    fetchComboboxRisorse().then(risorse => {
                        eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                            ckey: 'filtro_risorsa_task',
                            items: risorse
                        });
                    });
                    fetchComboboxStatiTask().then(stati => {
                        eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                            ckey: 'filtro_stato_task',
                            items: stati
                        });
                    });

                    fetchComboboxStatiTask().then(stati => {
                        this.state.rows_task.forEach(row => {
                            eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                                ckey: `stato_${row.id}`,
                                items: stati
                            });
                        });
                    });

                } else if (tab === KEYS.ORE) {
                    fetchComboboxRisorse().then(risorse => {
                        eventBus.trigger(EVENTS.COMBOBOX.UPDATE, {
                            ckey: 'filtro_risorsa_ore',
                            items: risorse
                        });
                    });
                }
                this.update({
                    currentTab: tab
                })
            },

            async saveTask(row) {
                const id = row.id
                const stato = this.$('#stato_' + id).value
                const result = await StoreService.saveTask(id, {
                    stato: stato
                })
                if (result.success) {
                    // puoi aggiornare direttamente lo stato locale se vuoi evitare un refetch
                    row.stato = stato
                    this.update()
                } else {
                    eventBus.trigger(EVENTS.UI.OPEN_MODAL_ERROR, {
                        ckey: "error",
                        title: "Errore nel salvataggio del task",
                        text: result.error
                    })
                    console.error(`❌ Errore nel salvataggio: ${result.error}`)
                }
            }
        }

    </script>
</commessa>
